export const checkGroupPayments = (arr, missionId) => {
  if (!Array.isArray(arr) || arr.length === 0) return 0;

  return arr.reduce((acc, elem) => {
    if (!elem || String(elem.missionId) !== String(missionId)) return acc;
    return acc + (Number(elem.sum) || 0);
  }, 0);
};
